<script lang="ts">
import type { AlertProps, AlertSlots } from '#ui/types';

export interface NoticeProps extends Omit<AlertProps, 'variant'> {}
</script>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';
import { useForwardProps } from 'reka-ui';
import { computed } from 'vue';

import { useAppConfig } from '#app/config';
import Alert from '#ui/components/Alert.vue';

const props = defineProps<NoticeProps>();
const slots = defineSlots<AlertSlots>();

const appConfig = useAppConfig();

const iconMap: Record<string, string> = {
	info: appConfig.ui.icons.info,
	primary: appConfig.ui.icons.info,
	success: appConfig.ui.icons.success,
	warning: appConfig.ui.icons.warning,
	error: appConfig.ui.icons.error,
	neutral: appConfig.ui.icons.info,
};

const resolvedIcon = computed(() => props.icon ?? iconMap[props.color ?? 'info']);

const forwarded = useForwardProps(reactiveOmit(props, ['icon']));
</script>

<template>
	<Alert v-bind="forwarded" variant="subtle" :icon="resolvedIcon">
		<template v-for="(_, name) in slots" #[name]="slotData: any">
			<slot :name v-bind="slotData" />
		</template>
	</Alert>
</template>
